export class SkillTag {
    constructor(name: string) {
        this.name = name;
        this.selected = false;
    }
    name: string;
    selected: boolean;
}
